import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TenantDto } from '@nusign/picflow-backend-types';

@Component({
  selector: 'app-tenant-icon-loader',
  templateUrl: './tenant-icon-loader.component.html',
  styleUrls: ['./tenant-icon-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class TenantIconLoaderComponent {
  @Input() tenant: TenantDto;
}
